<form class="form-inline">
	<div class="search-input-wrapper">
		<label for="field-value" class="sr-only">{{locale "searchValue"}}</label>
        <div class="grid-flex-select-container region-enum-select"></div>
		<button type="button" class="close" data-control="removeFilter">{{icon name="close" text="Remove filter"}}</span></button>
	</div>
    <button type="submit" name="submit" class="btn btn-sm btn-primary" disabled="disabled">{{locale "apply"}}</button>
    <button type="button" name="clear" class="btn btn-sm btn-tertiary btn-clear-filter hidden">{{locale "clear"}}</button>
</form>
